var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      attrs: { "show-edition": "" },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              _c("div", { staticClass: "row px-3" }, [
                _c("div", { staticClass: "col-12 mb-3 mt-2" }, [
                  _c("em", {
                    staticClass:
                      "fas fa-plus rounded-circle p-1 mr-2 color-green shadow bg-white"
                  }),
                  _c("span", [_vm._v("Añadir Dirección Postal")])
                ])
              ]),
              _c("div", { staticClass: "px-5" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-4 col-sm-12" },
                    [
                      _c("custom-drop-down", {
                        attrs: {
                          fieldkey: "id",
                          fieldname: "description",
                          label: "Tipo:",
                          options: [],
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.model.type,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "type", $$v)
                          },
                          expression: "model.type"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("hr"),
                _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm" },
                    [
                      _c("custom-input", {
                        attrs: { label: "Dirección (Línea 1):" },
                        model: {
                          value: _vm.model.address1,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "address1", $$v)
                          },
                          expression: "model.address1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm" },
                    [
                      _c("custom-drop-down", {
                        attrs: {
                          fieldkey: "id",
                          fieldname: "description",
                          label: "Municipio:",
                          options: [],
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.model.municipality,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "municipality", $$v)
                          },
                          expression: "model.municipality"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm" },
                    [
                      _c("custom-input", {
                        attrs: { label: "Código Postal:" },
                        model: {
                          value: _vm.model.zipcode,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "zipcode", $$v)
                          },
                          expression: "model.zipcode"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-md-4 col-sm-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col mb-2" },
                        [
                          _c("custom-input", {
                            attrs: { label: "Dirección (Línea 2):" },
                            model: {
                              value: _vm.model.address2,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address2", $$v)
                              },
                              expression: "model.address2"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("custom-input", {
                            attrs: { label: "Dirección (Línea 3):" },
                            model: {
                              value: _vm.model.address3,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address3", $$v)
                              },
                              expression: "model.address3"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col d-flex align-items-end" },
                    [
                      _c("custom-text-area", {
                        staticClass: "w-100",
                        attrs: {
                          label: "Anotaciones Adicionales:",
                          placeholder:
                            "Escribir información adicional de cómo llegar…",
                          rows: "4"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col d-flex justify-content-end align-items-end mb-2"
                    },
                    [
                      _c("action-button", {
                        staticClass: "mr-2 w-15",
                        attrs: {
                          i: "fas fa-times-circle",
                          text: "Cancelar",
                          variant: "outline-danger"
                        }
                      }),
                      _c("action-button", {
                        staticClass: "w-15",
                        attrs: { text: "Añadir", variant: "success" }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-sm-1 d-flex align-items-center justify-content-center"
          },
          [_c("icon", { attrs: { i: "fas fa-map-marker-alt" } })],
          1
        ),
        _c("div", { staticClass: "col-sm" }, [
          _c("span", { staticClass: "font-14 color-secondary-6" }, [
            _vm._v("Tipo:")
          ]),
          _c("p", { staticClass: "font-16 color-black" }, [
            _vm._v(_vm._s(_vm.data.type))
          ])
        ]),
        _c("div", { staticClass: "col-sm" }, [
          _c("span", { staticClass: "font-14 color-secondary-6" }, [
            _vm._v("Dirección Física:")
          ]),
          _c("p", { staticClass: "font-16 color-black" }, [
            _vm._v(_vm._s(_vm.data.address))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-sm d-flex justify-content-end mr-5" },
          [_c("drop-down", { attrs: { items: _vm.actions } })],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }